import React from 'react'
import { InteractiveContentRenderer } from '../interactive'

const InteractiveDemo: React.FC = () => {
  const demoContent = [
    {
      type: 'text',
      content: 'Chào mừng bạn đến với demo nội dung tương tác! Dưới đây là các ví dụ về các loại nội dung tương tác mới.'
    },
    {
      type: 'interactive_oscillation',
      title: 'Demo mô phỏng dao động điều hòa',
      description: 'Thử nghiệm với các tham số để hiểu về dao động điều hòa'
    },
    {
      type: 'interactive_question',
      question: 'Dao động điều hòa là gì?',
      options: [
        'Chuyển động thẳng đều',
        'Chuyển động lặp đi lặp lại quanh vị trí cân bằng theo quy luật sin/cos',
        'Chuyển động tròn đều',
        'Chuyển động rơi tự do'
      ],
      correctAnswer: 1,
      explanation: 'Dao động điều hòa là dao động mà li độ biến thiên theo thời gian theo quy luật hàm sin hoặc cosin.',
      hint: 'Hãy nghĩ về chuyển động của con lắc đồng hồ',
      difficulty: 'easy'
    },
    {
      type: 'interactive_formula',
      title: 'Công thức dao động điều hòa',
      formula: 'x = A\\cos(\\omega t + \\varphi)',
      variables: [
        {
          symbol: 'A',
          name: 'Biên độ',
          unit: 'cm',
          min: 1,
          max: 20,
          default: 10,
          step: 0.5
        },
        {
          symbol: 'ω',
          name: 'Tần số góc',
          unit: 'rad/s',
          min: 0.5,
          max: 5,
          default: 2,
          step: 0.1
        },
        {
          symbol: 't',
          name: 'Thời gian',
          unit: 's',
          min: 0,
          max: 10,
          default: 0,
          step: 0.1
        },
        {
          symbol: 'φ',
          name: 'Pha ban đầu',
          unit: 'rad',
          min: 0,
          max: 6.28,
          default: 0,
          step: 0.1
        }
      ],
      resultFormula: 'A * cos(ω * t + φ)',
      resultUnit: 'cm',
      description: 'Thay đổi các tham số để xem li độ thay đổi như thế nào',
      insights: [
        'Khi t = 0, li độ x₀ = A·cos(φ)',
        'Li độ dao động trong khoảng từ -A đến +A',
        'Chu kỳ dao động T = 2π/ω'
      ]
    },
    {
      type: 'interactive_exploration',
      title: 'Khám phá các đặc trưng của dao động',
      description: 'Tìm hiểu từng bước về các đặc trưng quan trọng',
      steps: [
        {
          id: 'amplitude',
          title: 'Biên độ dao động',
          content: 'Biên độ A là giá trị cực đại của li độ, cho biết vật dao động xa nhất bao nhiêu so với vị trí cân bằng.',
          reveal: 'Biên độ luôn dương và có đơn vị mét. Biên độ càng lớn, dao động càng mạnh.'
        },
        {
          id: 'frequency',
          title: 'Tần số và chu kỳ',
          content: 'Chu kỳ T là thời gian thực hiện một dao động toàn phần. Tần số f = 1/T.',
          reveal: 'Tần số góc ω = 2π/T = 2πf. Tần số càng lớn, dao động càng nhanh.'
        },
        {
          id: 'phase',
          title: 'Pha dao động',
          content: 'Pha dao động φ(t) = ωt + φ₀ xác định trạng thái dao động tại thời điểm t.',
          reveal: 'Pha ban đầu φ₀ phụ thuộc vào điều kiện ban đầu của dao động.'
        }
      ]
    }
  ]

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          🎯 Demo Nội Dung Tương Tác
        </h1>
        <p className="text-lg text-gray-600">
          Trải nghiệm các tính năng tương tác mới giống Brilliant.org
        </p>
      </div>

      <InteractiveContentRenderer 
        content={demoContent}
        onProgress={(progress) => {
          console.log('Demo progress:', progress)
        }}
      />
    </div>
  )
}

export default InteractiveDemo